/* eslint-disable quote-props */
import { Potion as PotionType } from '~/../api/common.types';
import { capitalizeFirstLetter, potionType } from '~/utils/utils';

// const colorMessageMapper = {
//   purple:
//     'Level 1: Free, L2 - 5: Dead Warriors whose levels add up to the level of the Warrior being revived',
//   green:
//     'Level 1 - 2: Free, L3 - 5: Dead Warriors whose levels add up to the level of the Warrior being revived',
//   blue: 'Level 1 - 5: Free',
//   '': 'Potion is empty and not eligible',
// };

function Potion({
  potion,
  potionId,
  setPotionId,
  setDeadWarriorIds,
}: {
  potion: PotionType;
  potionId: string | null; // use string since ID can be number 0 which is falsy
  setPotionId: any;
  setDeadWarriorIds: any;
}) {
  const color = potionType(potion);
  const potonIdFormatted = potion.id.toString();
  const handleClick = () => {
    setDeadWarriorIds([]);
    if (potionId == potonIdFormatted) {
      setPotionId(null);
    } else {
      setPotionId(potonIdFormatted);
    }
  };
  return (
    <button
      className={`grid__item ${
        potionId && potionId == potonIdFormatted ? 'is-selected' : ''
      }`}
      onClick={handleClick}
    >
      <div className="potion-media">
        <img src={potion.image} alt="Potion" />
      </div>
      <p className="grid-potions__text">{capitalizeFirstLetter(color)}</p>
    </button>
  );
}

function Potions({
  potions,
  potionId,
  setPotionId,
  setDeadWarriorIds,
}: {
  potions: Array<PotionType> | [] | undefined;
  potionId: string | null;
  setPotionId: any;
  setDeadWarriorIds: any;
}) {
  return (
    <div className="grid-potions">
      {potions?.map((potion: PotionType, i) => (
        <Potion
          potion={potion}
          key={i}
          setPotionId={setPotionId}
          potionId={potionId}
          setDeadWarriorIds={setDeadWarriorIds}
        />
      ))}
    </div>
  );
}

export default Potions;
